export const projectTags = ['Active Project', 'Scenarios', 'Org Template Libraries']
